/* eslint-disable */
import axios from '@/services/axios'

export default {
    getVoteDataDonutBar(search, source) {
        return axios.get("/vote/getVoteDataDonutBar", { params: search, cancelToken: source.token });
    },
    getVoteDataLine(search, source) {
        return axios.post("/vote/getVoteDataLine", search, { cancelToken: source.token });
    },
    getVoteDataStack(search, source) {
        return axios.get("/vote/getVoteDataStack", { params: search, cancelToken: source.token });
    },

    getVoteDataNet(search, source) {
        return axios.post("/vote/getVoteDataNet", search, { cancelToken: source.token });
    },

    getCandidateList(search, source) {
        return axios.post("/vote/getCandidateList", search, { cancelToken: source.token });
    },
    getVoteRelationDataLine(search, source) {
        return axios.post("/vote/getVoteRelationDataLine", search, { cancelToken: source.token });
    },
    
    

    // getCompetitionDataTable(search, source) {
    //     return axios.post("/competition/getCompetitionDataTable", search, { cancelToken: source.token });
    // },
    
};
